<div class="headline">
    {{contractPreview}}
</div>
<ng-container *ngFor="let info of subTitles">
    <div class="sub-title">
        <span class="sub">
            {{info.type}}
        </span>
        <span class="main">
            {{info.value}}
        </span>
    </div>
</ng-container>